import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 5H3v14h18V5zm-2 12H5V7h14v10z"
}), 'CropLandscapeSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CropLandscapeSharp.js
// module id = 3017
// module chunks = 2